import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React from 'react';
import PropTypes from 'prop-types';
import { classes, st } from './BadgeIndicator.st.css';

var BadgeIndicator = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(BadgeIndicator, _React$PureComponent);

  var _super = _createSuper(BadgeIndicator);

  function BadgeIndicator() {
    _classCallCheck(this, BadgeIndicator);

    return _super.apply(this, arguments);
  }

  _createClass(BadgeIndicator, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          dataHook = _this$props.dataHook,
          className = _this$props.className,
          skin = _this$props.skin;
      return /*#__PURE__*/React.createElement("div", {
        "data-hook": dataHook,
        className: st(classes.root, {
          skin: skin
        }, className)
      });
    }
  }]);

  return BadgeIndicator;
}(React.PureComponent);

BadgeIndicator.displayName = 'BadgeIndicator';
BadgeIndicator.propTypes = {
  /** Applies a data-hook HTML attribute that can be used in the tests */
  dataHook: PropTypes.string,

  /** Specifies a CSS class name to be appended to the component’s root element */
  className: PropTypes.string,

  /** Represents the color of the badge */
  skin: PropTypes.oneOf(['standard', 'alert', 'warning', 'success'])
};
BadgeIndicator.defaultProps = {
  skin: 'standard'
};
export default BadgeIndicator;